'use client';

/**
 * Il guscio dell'applicazione: menu laterale, selettore di
 * organizzazione/disciplina, provider di sessione — TUTTO cio' che assume
 * un amministratore già autenticato.
 *
 * ⛔ `/play` (decisions/link-giocatore-al-tavolo.md §6.4) non è una pagina
 * dell'amministrazione: chi arriva da un link stampato non ha una sessione
 * admin, e mostrargli il menu laterale lo farebbe sembrare nel posto
 * sbagliato — oltre a montare `OrgDisciplineProvider`, che PATCHA
 * `window.fetch` per aggiungere gli header di contesto: inutile e fuorviante
 * per chi parla solo con `/api/play/*`.
 */
import { usePathname } from 'next/navigation';

import { OrgDisciplineProvider } from '../contexts/OrgDisciplineContext';
import { SessionAuthProvider } from '../contexts/StaticAuthContext';
import GlobalScopeBar from './GlobalScopeBar';
import Navigation from './Navigation';

export default function AppShell({ children }: { children: React.ReactNode }) {
  const pathname = usePathname();

  if (pathname?.startsWith('/play')) {
    return <main className="min-h-screen bg-gray-50">{children}</main>;
  }

  return (
    <SessionAuthProvider>
      <OrgDisciplineProvider>
        <div className="flex h-screen flex-col">
          <div className="flex flex-1 flex-col md:flex-row overflow-hidden">
            <Navigation />
            <div className="flex flex-col flex-1 min-w-0 overflow-hidden">
              <GlobalScopeBar />
              <main className="flex-1 overflow-auto">{children}</main>
            </div>
          </div>
        </div>
      </OrgDisciplineProvider>
    </SessionAuthProvider>
  );
}
